import Moment from "moment";

export function fechaBase(fecha, formato) {
  return Moment(fecha).format(formato);
}

export function openLink(url) {
  window.open(url);
}
